import { AuthProvider as ap } from "react-oidc-context"
import { WebStorageStateStore } from "oidc-client-ts"
import { OidcConfig } from "./ConstantService"

const oidcConfig = {
  ...OidcConfig,
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
}

function AuthProvider(props) {
  return ap({ ...props, ...oidcConfig })
}

export default AuthProvider
